module.exports = __webpack_public_path__ + "static/media/img11.b655dd74.jpg";